import React, { useState } from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { ChevronDown } from 'lucide-react';

interface SpeedSelectorProps {
  value: number;
  onValueChange: (value: number) => void;
  disabled?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const SpeedSelector: React.FC<SpeedSelectorProps> = ({
  value,
  onValueChange,
  disabled = false,
  onOpenChange
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    onOpenChange?.(open);
  };

  const speeds = [
    { value: 0.5, label: '0.5x' },
    { value: 0.75, label: '0.75x' },
    { value: 1.0, label: '1.0x' },
    { value: 1.25, label: '1.25x' },
    { value: 1.5, label: '1.5x' },
    { value: 2.0, label: '2.0x' }
  ];

  const currentLabel = speeds.find(speed => speed.value === value)?.label || '1.0x';

  return (
    <DropdownMenuPrimitive.Root open={isOpen} onOpenChange={handleOpenChange}>
      <DropdownMenuPrimitive.Trigger
        className="select-trigger"
        disabled={disabled}
        aria-label="选择播放速度"
      >
        <span className="select-value">{currentLabel}</span>
      </DropdownMenuPrimitive.Trigger>

      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          className="select-content select-content-left"
          side="top"
          align="center"
          style={{
            maxHeight: 'none',
            transform: 'translateY(-33px)',
            overflow: 'visible'
          }}
        >
        {speeds.map((speed) => (
          <DropdownMenuPrimitive.Item
            key={speed.value}
            className="select-item"
            data-selected={value === speed.value ? 'true' : 'false'}
            onSelect={() => {
              onValueChange(speed.value);
            }}
          >
            {speed.label}
          </DropdownMenuPrimitive.Item>
        ))}
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuPrimitive.Root>
  );
};

export default SpeedSelector;
